import { RefusalTypeFlags } from '@/enums';

export const list = [
  { key: RefusalTypeFlags.NON_COMPETITIVE, label: 'Non-competitive pricing' },
  { key: RefusalTypeFlags.NON_DIFFERENTIATED, label: 'Non-differentiated offering' },
  { key: RefusalTypeFlags.KNOWN_COMPANY, label: 'Already aware of this company' },
];
